import React, { useEffect, useState } from "react";
import Header from "../../Components/Header";
import './index.scss'
import useGetNotificationsApi from "../../Global/Api/Notifications/getNotificationsApi";
import moment from "moment";
import {useSelector} from "react-redux";
import Pagination from "../../Components/Pagination";
import {setActiveJobStatus, setCurrentPage, setSearchValue} from "../../Store/Slice/jobsSlice";
import {Paginate} from "../../Components/Paginate";
import {Link} from "react-router-dom";

const Notifications = () => {
  const [page, setPage] = useState(1);
  const getNotifications = useGetNotificationsApi();
  const {notifications} = useSelector((state) => state?.rootReducer.techsbookSlice);

  const formatParams = () => {
    const params = new URLSearchParams();
    params.append('page', String(page));
    return params
  }

  useEffect(() => {
    const formattedParams = formatParams();
    getNotifications.get(formattedParams)
  }, [page])

  const handlePageClick = (event) => {
    const formattedParams = formatParams();
    setPage(event.selected + 1)
    getNotifications.get(formattedParams)
  };

  const renderNotifications = () => {
    return notifications?.data?.map((item, index) => (
      <Link
        onClick={() => {
          localStorage.setItem("jobId", item?.job_id);
          getNotifications.mark({
            params: item?.id,
            body: {}})
        }}
        to={`/jobs/${item?.job_id}`}
        key={item?.id}
        className='notifications__item'
      >
        <div className="notifications__item-inner">
          <div className="notifications__left">
            <div className="notifications__item-icon">
              <img src="/assets/icons/complete-job.svg" alt=""/>
            </div>
          </div>
          <div className="notifications__info">
            <p className="notifications__name">{item?.title} a Job ID# {item?.job_id}</p>
            <p className="notifications__desc">{item?.description}</p>
            <p className="notifications__time">{moment(item?.created_at).format("YYYY-MM-DD hh:mm A")}</p>
          </div>
        </div>
        <div className="notifications__right">
          {item?.read_at === null && (<div className="notifications__indicator"></div>)}
        </div>
      </Link>
    ));
  };

  return (
    <div className="notifications">
      <Header title={"Notifications"}/>
      <div className="notifications__list">
        {renderNotifications()}
      </div>
      {notifications?.totalPage > 1 && (
        <Paginate currentPage={page} setCurrentPage={setPage} pageCount={notifications?.totalPage}/>
      )}
    </div>
  );
};

export default Notifications;
